"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deduplicateSlashes = function (url) { return url.replace(/\/{2,}/g, '/'); };
exports.default = deduplicateSlashes;
